<template>
  <div>
    <form-label v-if="label" :text="fieldLabel" :hint="fieldHint" :for="id"></form-label>
    <div class="uk-form-controls">
      <div target="true" slot="field" class="uk-flex" uk-form-custom v-if="showSelected">
        <input type="file" :name="name" :multiple="multiple" :disabled="!enabled" @change="updateSelectedFiles" @blur="triggerChangeAndValidate" ref="input">
        <input class="uk-input uk-flex-1" :class="{'uk-form-danger': isDanger, 'uk-form-success': isSuccess}" type="text" :id="id" :value="selectedFiles" readonly>
        <button type="button" class="uk-button uk-button-default" v-if="buttonLabel">{{ buttonLabel }}</button>
      </div>
      <div slot="field" class="uk-width-1-1" uk-form-custom v-else>
        <input type="file" :id="id" :name="name" :multiple="multiple" ref="input" @blur="triggerChangeAndValidate">
        <button type="button" class="uk-button uk-button-default uk-width-1-1" v-if="buttonLabel" :disabled="!enabled">
          {{ buttonLabel }}
        </button>
      </div>
    </div>
    <form-error v-for="(error, index) in errors" :key="index" :error="error"></form-error>
    <ul>
      <li v-for="(file, key) in fieldValue"><span class="uk-hidden" @click="removeItem(key)">[x]</span> {{ file.name }}</li>
    </ul>
  </div>

</template>

<script>
import FormField from "rubinred/forms/js/mixins/FormField";
import Validator from 'validatorjs';

export default {
  mixins: [FormField],
  props: {
    value: {
      type: Array,
      default: () => []
    },
    showSelected: {
      type: Boolean,
      default: true,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    buttonLabel: {
      type: String,
      default: 'Select'
    },
    isMultipart: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      selectedFiles: '',
      fieldValue: []
    }
  },
  methods: {
    validateField(fields = {}, labels = {}) {
      let validations = {}

      validations[this.slug] = this.getValidations()

      let fieldValues = {
        [this.slug]: this.fieldValue,
      }
      let fieldLabels = {
        [this.slug]: this.label,
      }

      Validator.register('mimes', function (value, requirement, attribute) {
        if (!value) {
          return false
        }

        let len = Object.keys(value).length;

        for(let i = 0; i < len; i++){

          let name = value[i].name ? value[i].name : '';
          let type = value[i].type ? value[i].type : '';

          let check =
            name.includes('.pdf') ||
            type.includes('pdf') ||
            name.includes('.dxf') ||
            type.includes('dxf') ||
            name.includes('.jpg') ||
            type.includes('jpg') ||
            name.includes('.jpeg') ||
            type.includes('jpeg');

          if(check === false){
            return false;
          }
        }

        return true;
      });

      Validator.register('size', function (value, requirement, attribute) {
        let files = value
        files.reduce((n, {size}) => n + size, 0)

        return files.reduce((n, {size}) => n + size, 0) < 2048;
      });

      let validator = new Validator(Object.assign(fieldValues, fields), validations);
      validator.setAttributeNames(Object.assign(fieldLabels, labels));
      validator.passes();

      if (validator.errors.first(this.slug)) {
        this.errors = [validator.errors.first(this.slug)];
      } else {
        this.errors = [];
      }

      if (this.errors.length) {
        this.fieldValue = [];
        this.$set(this.messages, this.slug, this.errors)
      } else {
        this.$delete(this.messages, this.slug)
      }

      return {
        valid: Object.keys(this.errors).length === 0,
        messages: this.messages,
      }
    },
    updateSelectedFiles() {
      if (!this.$refs.input) {
        return;
      }

      this.fieldValue = [];
      for (let i = 0; i < this.$refs.input.files.length; i++) {
        this.fieldValue.push(this.$refs.input.files[i]);
      }

      this.selectedFiles = this.fieldValue.map(file => file.name).join(', ');
    },
    removeItem(key){
      //this.fieldValue = this.fieldValue.splice(key, 1);
    }
  },
}
</script>



// WEBPACK FOOTER //
// public/themes/frontend/mtg/extensions/rubinred/forms/assets/js/components/FormFile.vue